<script setup>
import Conversations from "@/Components/Messaging/Conversations.vue";
</script>

<template>
  <v-container fluid class="overflow-hidden overflow-y-scroll" elevated="0">
    <Conversations/>
  </v-container>
</template>

<style scoped>

</style>